module.exports = __webpack_public_path__ + "img/mypage.20394c4a.png";